import React, { useCallback, useState } from "react";
import { useField } from "formik";
import { Label } from "reactstrap";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

import Input from "../Input";
import ErrorMessageDefault from "../../base/components/ErrorMessageDefault";
import { ReactComponent as ViewPassword } from "../../assets/ic-show.svg";
import { ReactComponent as HidePassword } from "../../assets/ic-hide-grey.svg";
import { noop } from "@helpers/common";
import { getErrorLabel } from "@helpers/validation";

import styles from "./index.module.scss";

const TEXT_TYPE = "text";
const PASSWORD_TYPE = "password";

const FormikPassword = ({
  placeholder,
  name,
  type,
  maxLength,
  readOnly,
  label,
  disabled,
  wrapperClassName,
  onChange = noop,
  ErrorMessage = ErrorMessageDefault,
  min,
  max,
  isHideEyeOption = false,
}) => {
  const [currentType, updateCurrentType] = useState(type);
  const [isHidePassword, updateIsHidePassword] = useState(true);

  const [field, meta] = useField({ name, type, placeholder });
  const isInvalid = meta.error && meta.touched;
  const { t } = useTranslation("labels");
  const { t: t1 } = useTranslation("placeholders");
  const { t: t2 } = useTranslation("errors");

  const handleChange = (event) => {
    field.onChange(event);
    onChange(event);
  };

  const handleViewPassword = useCallback(() => {
    updateCurrentType((type) =>
      type === TEXT_TYPE ? PASSWORD_TYPE : TEXT_TYPE,
    );
    updateIsHidePassword((isHide) => !isHide);
  }, []);

  const errorLabel = getErrorLabel(label);

  return (
    <section className={classNames("form-control-wrapper", wrapperClassName)}>
      {label && (
        <Label for={name} className={classNames({ disabled }, styles.label)}>
          {t(label)}
        </Label>
      )}
      <div className="position-relative">
        <Input
          {...field}
          type={currentType}
          onChange={handleChange}
          autoComplete="new-password"
          maxLength={maxLength}
          readOnly={readOnly}
          placeholder={t1(placeholder)}
          className={classNames({
            invalid: isInvalid,
            ["pe-4"]: true,
          })}
          isError={isInvalid}
        />
        {!isHideEyeOption && (
          <button
            className={classNames(
              "btn-resetStyle position-absolute",
              styles.eyeButton,
            )}
            onClick={handleViewPassword}
            type="button"
            tabIndex={-1}
          >
            {isHidePassword ? (
              <ViewPassword
                className={classNames("pointer-events-none", styles.eyeIcon)}
              />
            ) : (
              <HidePassword
                className={classNames("pointer-events-none", styles.eyeIcon)}
              />
            )}
          </button>
        )}
      </div>
      {isInvalid && (
        <ErrorMessage className="position-absolute" name={name}>
          {t2(meta.error, { label: t(errorLabel), min, max })}
        </ErrorMessage>
      )}
    </section>
  );
};

export default FormikPassword;
